export function checkIsTableRowFocused(item, focusedRow) {
  return item.id === focusedRow
}
